export default __webpack_public_path__ + "static/media/hg.dcccd0c9.png";